module.exports = __webpack_public_path__ + "img/AILogo4.e5afb75b.png";